module.exports = __webpack_public_path__ + "static/img/page503.2d13e83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page503.png
// module id = sRuD
// module chunks = 0